import { render, staticRenderFns } from "./CompleteNewPassword.vue?vue&type=template&id=1a77a9a0&"
import script from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports